import React from 'react'
import PaymentLinkQrWithPatientDetails from 'src/chamberScreen/layout/components/PaymentLinkQrWithPatientDetails'
import PaymentSuccessfulByQR from 'src/chamberScreen/layout/components/PaymentSuccessfulByQR'
import SourceImagePopup from 'src/chamberScreen/layout/components/SourceImagePopup'
import { SIGNALING_COMMANDS } from 'src/consumer/constants'

export default function PopupQRInnerComponent({ type, ...rest }) {
  if (type === SIGNALING_COMMANDS.SHOW_BOOKING_PAYMENT_LINK_QR_WITH_PATIENT_DETAILS) {
    return <PaymentLinkQrWithPatientDetails {...rest} />
  }
  if (type === SIGNALING_COMMANDS.QR_PAYMENT_SUCCESS) {
    return <PaymentSuccessfulByQR {...rest} />
  }

  return <SourceImagePopup {...rest} />
}
